module.exports = __webpack_public_path__ + "img/record-running.2181ec88.gif";